import React from 'react'
import clsx from 'clsx'
import { type NavigationItem } from '../types'
import { useLocation, useNavigate } from 'react-router-dom'

/**
 * NavigationMenu displays the page navigation options on the left side of the UI.
 * @returns {any}
 */
function NavigationMenu (): JSX.Element {
  const location = useLocation()
  const navigate = useNavigate()

  const navItems: NavigationItem[] = [
    {
      label: 'Dashboard',
      route: '/home'
    },
    {
      label: 'Logout',
      route: '/'
    }
    /*
    {
      label: 'Customers',
      route: '/users'
    },
    {
      label: 'Reports',
      route: '/reports'
    }
    */
  ]

  return (
    <div className="position-sticky pt-3">
      <ul className="nav flex-column">
        {
          navItems.map((navItem: NavigationItem, i: number) => (
            <li className="nav-item" key={i}>
              <button className={clsx('nav-link', { active: location.pathname === navItem.route })} aria-current="page" onClick={() => { navigate(navItem.route) }}>
                <span data-feather="home"></span>
                { navItem.label }
              </button>
            </li>
          ))
        }
      </ul>
    </div>
  )
}

export default NavigationMenu
